import { setUser as sentrySetUser } from '@sentry/browser';
import { PieceSelector } from './PieceSelector';

export function RegisterPlayer({
	name,
	color,
	colors,
	maxPlayers,
	playAs = 'player',
	numberMode = false,
	extraField = false,
	onChange,
	onLeave,
}: {
	playAs: 'player' | 'team';
	name: string;
	color: string;
	colors?: string[];
	maxPlayers: number;
	numberMode?: boolean;
	extraField?: boolean;
	onChange: (name: string, color: string, companyOrFunction?: string) => void;
	onLeave: () => void;
}) {
	const view: HTMLElement = (
		<div class="flex w-full flex-col items-center gap-2 p-6 md:max-w-screen-md">
			{/* <img src="/logo.svg" class="size-24" alt="bedrijfshelden logo" /> */}
			<h1 class="text-3xl font-bold text-gray-900">{playAs === 'player' ? __`Who are you?` : __`Who are you? (Team name)`}</h1>
			<form action="" class="mt-3 flex flex-col gap-6">
				<div class="flex flex-col gap-2">
					<label for="player-name" class="font-semibold text-gray-800">
						{playAs == 'player' ? __`Name` : __`Team name`}
					</label>
					<input
						type="text"
						id="player-name"
						name="player-name"
						placeholder={playAs == 'player' ? __`First name` : __`Team name`}
						maxlength="14"
						class="rounded-sm border border-gray-300 bg-gray-50 p-2"
						value={name}
						autocomplete="off"
						on:input={(e: InputEvent) => {
							const v = (e.target as HTMLInputElement).value;
							name = v;
							sentrySetUser({ username: name.trim() });
							onChange(name.trim(), color);
						}}
					/>
				</div>
				{extraField && (
					<div class="flex flex-col gap-2">
						<label for="player-company" class="font-semibold text-gray-800">
							Functie of bedrijf
						</label>
						<input
							type="text"
							id="player-company"
							name="player-company"
							placeholder={__`Bijv. Marketing`}
							maxlength="20"
							class="rounded-sm border border-gray-300 bg-gray-50 p-2"
							autocomplete="off"
							on:input={(e: InputEvent) => {
								const v = (e.target as HTMLInputElement).value;
								onChange(name.trim(), color, v.trim());
							}}
						/>
					</div>
				)}
				<div class="flex flex-col gap-2">
					<label for="player-piece" class="font-semibold text-gray-800">
						{__`Pawn`}
					</label>
					<PieceSelector
						maxPlayers={maxPlayers}
						colors={colors}
						numberMode={numberMode}
						onChange={(selection) => {
							if (selection === undefined) {
								waitMsg.innerText = __`Choose a pawn.`;
							} else {
								waitMsg.innerText = __`Wait for the game master to start the game.`;
							}
							color = selection ?? '';
							onChange(name, color);
						}}
					/>
					<small wait-msg class="mt-4 text-center text-gray-700"></small>
				</div>
			</form>
			<button
				class="rounded-md border border-gray-300 bg-gray-200 px-3 py-2 text-sm font-semibold leading-none text-gray-800 shadow-sm hover:bg-gray-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-600"
				on:click={() => {
					localStorage.clear();
					window.location.reload();
					onLeave();
				}}
			>
				{__`Leave session`}
			</button>
		</div>
	);
	const waitMsg = view.querySelector('[wait-msg]') as HTMLElement;

	return view;
}
